import React, { Fragment, useState, useEffect } from "react";
import Grid from '@mui/material/Grid';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import DeviceDealerList from "./deviceDealersList";
import { getCountryCodeISO } from "../../utils/general";
import { getDeviceDealerInfoByPSN, getDeviceDealerInfoByDealerId } from "../../action/deviceDealer";
import DisplayDeviceDealerDeatils from "./deviceDealerDetailsPage";
import Alert from "../layout/Alert";
import customConfig from "../../config";
import { selectMenuProps } from "../../utils/selectMenuProps";
import "../Common/searchFilterLayout.css";

const GetDealerInfo = ({
    allowedDeviceCategories,
    allowedCompanyBrand,
    allowedCountries,
    setAlert,
    onEditDeviceDealerDetails,
    showUpdatedDealerInfo,
    userRoleInfo
}) => {

    const [dealerSearchBy, setDealerSearchBy] = useState("dealerId")
    const [dealerSearchByID, setDealerSearchByID] = useState("")
    const [searchButtonClicked, setSearchButtonClicked] = useState("")
    const [dealerSearchByCountry, setDealerSearchByCountry] = useState("Select Country")
    const [dealerSearchByPSN, setDealerSearchByPSN] = useState("")

    const [deviceDealerInfo, setDeviceDealerInfo] = useState({})

    useEffect(() => {
        setDeviceDealerInfo({});
    }, [dealerSearchBy, dealerSearchByCountry, dealerSearchByID, dealerSearchByPSN, searchButtonClicked])

    useEffect(() => {
        if (showUpdatedDealerInfo) {
            setDeviceDealerInfo({})
        }
    }, [showUpdatedDealerInfo])

    function handleEditDeviceDealerDetails(deviceDealerDetails) {
        onEditDeviceDealerDetails(deviceDealerDetails)
    }

    function handleSearchButtonClicked() {
        setSearchButtonClicked(true)

        if (dealerSearchBy==="productSerialNumber") {
            if (dealerSearchByPSN && dealerSearchByPSN.length!==0) {
                getDeviceDealerInfoByPSN(dealerSearchByPSN)
                    .then((data) => {
                        setDeviceDealerInfo(data)
                    })
                    .catch((err) => {
                        setAlert(err?.response?.data?.message ?? "Failed to Get Dealer Details", "danger")
                    })
            }
            else {
                setAlert("Invalid Product Serial Number", "danger")
            }
        }
        else if (dealerSearchBy==="dealerId") {
            if (dealerSearchByID && dealerSearchByID.length!==0) {
                getDeviceDealerInfoByDealerId(dealerSearchByID)
                    .then((data) => {
                        setDeviceDealerInfo(data)
                    })
                    .catch((err) => {
                        setAlert(err?.response?.data?.message ?? "Failed to Get Dealer Details", "danger")
                    })
            }
            else {
                setAlert("Invalid Dealer ID", "danger")
            }
        }
        else {
            // search is by country.. there we have to display the dealer list instead of single dealer
            if (!dealerSearchByCountry || (dealerSearchByCountry && dealerSearchByCountry==="Select Country") ||
                (dealerSearchByCountry && dealerSearchByCountry.length===0)
            ) {
                setAlert("Invalid Country", "danger")
            }
        }
    }

    function handleDeleteDeviceDealerDetails() {
        setDeviceDealerInfo({})
    }

    return (
        <Fragment>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Alert />
                </Grid>
                <Grid item xs={12}>
                    <div className="content-block bottom-shadow mb-0 search-filter-block get-dealer-info-filter" style={{ width: "100%", minWidth: 0 }}>
                        <div className="p-15">
                            <div className="search-filter-filter">
                                <div className="search-filter-title">
                                    <span className="black-text font-600">Search Device Dealer</span>
                                </div>
                                <div className="search-filter-controls">
                                <span className="search-filter-search-by">Search By</span>
                                <FormControl variant="outlined" size="small" className="search-filter-type-select">
                                    <Select
                                        name="dealerSearchBy"
                                        value={dealerSearchBy}
                                        onChange={(e) => {
                                            setSearchButtonClicked(false);
                                            setDealerSearchBy(e.target.value);
                                        }}
                                        MenuProps={selectMenuProps}
                                    >
                                        <MenuItem value="dealerId">Dealer Id</MenuItem>
                                        <MenuItem value="productSerialNumber">Product Serial Number</MenuItem>
                                        <MenuItem value="dealerCountry">Country</MenuItem>
                                    </Select>
                                </FormControl>
                                <div className="search-filter-input-wrap">
                                    {dealerSearchBy === "dealerId" && (
                                        <div className="search-device not-found right">
                                            <i className="material-icons search-icon"> search</i>
                                            <input
                                                className="add-input md border-0"
                                                placeholder="Enter Dealer Id"
                                                type="text"
                                                name="dealerSearchField"
                                                value={dealerSearchByID}
                                                onChange={(e) => {
                                                    setDealerSearchByID(e.target.value)
                                                    setSearchButtonClicked(false)
                                                }}
                                            />
                                        </div>
                                    )}
                                    {dealerSearchBy === "productSerialNumber" && (
                                        <div className="search-device not-found right">
                                            <i className="material-icons search-icon"> search</i>
                                            <input
                                                className="add-input md border-0"
                                                placeholder="Enter Product Serial Number"
                                                type="text"
                                                name="dealerSearchField"
                                                value={dealerSearchByPSN}
                                                onChange={(e) => {
                                                    setDealerSearchByPSN(e.target.value)
                                                    setSearchButtonClicked(false)
                                                }}
                                            />
                                        </div>
                                    )}
                                    {dealerSearchBy === "dealerCountry" && (
                                        <FormControl variant="outlined" size="small" className="search-filter-country-select">
                                            <Select
                                                displayEmpty
                                                renderValue={(v) => v || "Select Country"}
                                                value={dealerSearchByCountry}
                                                onChange={(e) => {
                                                    setDealerSearchByCountry(e.target.value);
                                                    setSearchButtonClicked(false);
                                                }}
                                                MenuProps={selectMenuProps}
                                            >
                                                <MenuItem value="Select Country">Select Country</MenuItem>
                                                {allowedCountries.filter((country) => getCountryCodeISO(country.toUpperCase())).map((element) => (
                                                    <MenuItem key={getCountryCodeISO(element.toUpperCase())} value={getCountryCodeISO(element.toUpperCase())}>
                                                        {getCountryCodeISO(element.toUpperCase())}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    )}
                                </div>
                                <div className="search-filter-btn">
                                    <input
                                        type="button"
                                        value="Search"
                                        className="btn orange-bg btn-block md no-shadow"
                                        onClick={() => handleSearchButtonClicked()}
                                    />
                                </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Grid>
            </Grid>
            <div className="mid-seprator"></div>
            {

                searchButtonClicked && dealerSearchBy==="dealerCountry" && dealerSearchByCountry && dealerSearchByCountry!=="Select Country" && dealerSearchByCountry.length > 0 &&
                <DeviceDealerList
                    countryCodeFilter={dealerSearchByCountry}
                    setAlert={setAlert}
                    onEditDeviceDealerDetails={handleEditDeviceDealerDetails}
                    showUpdatedDealerInfo={showUpdatedDealerInfo}
                    userRoleInfo={userRoleInfo}
                >
                </DeviceDealerList>
            }
            {
                searchButtonClicked && dealerSearchBy==="productSerialNumber" && dealerSearchByPSN && dealerSearchByPSN.length > 0 &&
                deviceDealerInfo && Object.keys(deviceDealerInfo).length > 0 &&
                <DisplayDeviceDealerDeatils
                    deviceDealerDetails={deviceDealerInfo}
                    displayEditDeleteButton={
                        (userRoleInfo.level > 4 || userRoleInfo.roles.includes(customConfig.roleCloudAdmin)) ? true : false
                    }
                    onEditDeviceDealerDetails={handleEditDeviceDealerDetails}
                    showUpdatedDealerInfo={showUpdatedDealerInfo}
                    onDeleteDeviceDealerDetails={handleDeleteDeviceDealerDetails}
                    setAlert={setAlert}
                >
                </DisplayDeviceDealerDeatils>
            }
            {

                searchButtonClicked && dealerSearchBy==="dealerId" && dealerSearchByID && dealerSearchByID.length > 0 &&
                deviceDealerInfo && Object.keys(deviceDealerInfo).length > 0 &&
                <DisplayDeviceDealerDeatils
                    deviceDealerDetails={deviceDealerInfo}
                    displayEditDeleteButton={
                        (userRoleInfo.level > 4 || userRoleInfo.roles.includes(customConfig.roleCloudAdmin)) ? true : false
                    }
                    onEditDeviceDealerDetails={handleEditDeviceDealerDetails}
                    onDeleteDeviceDealerDetails={handleDeleteDeviceDealerDetails}
                    setAlert={setAlert}
                >
                </DisplayDeviceDealerDeatils>
            }

        </Fragment>
    );
}

export default GetDealerInfo

